import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

/** Localized phrases cycled while T-Rex is processing a message. */
const STEP_KEYS = [
  "assistant.thinking.step1",
  "assistant.thinking.step2",
  "assistant.thinking.step3",
];
const CYCLE_MS = 2200;

/**
 * "Thinking" state shown while a reply is generating — a gently pulsing status
 * line that cycles through reassuring, localized phrases instead of dots.
 */
export const ThinkingIndicator = () => {
  const { t } = useTranslation();
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(
      () => setIndex((prev) => (prev + 1) % STEP_KEYS.length),
      CYCLE_MS
    );
    return () => clearInterval(id);
  }, []);

  return (
    <span className="relative block min-h-[1.25rem] text-sm leading-5 text-slate-500">
      <AnimatePresence mode="wait">
        <motion.span
          key={index}
          initial={{ opacity: 0, y: 4 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -4 }}
          transition={{ duration: 0.35, ease: "easeOut" }}
          className="inline-block animate-pulse"
        >
          {t(STEP_KEYS[index])}
        </motion.span>
      </AnimatePresence>
    </span>
  );
};
